import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0041_TCU_UART58 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0041_TCU_UART58',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'ZigBeeOneDeviceSetpoint',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayMac',
              isRead: 'true',
              interval: '593',
              texttableentry: 'GatewayMac',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteLocalNetworkStatus',
              isRead: 'true',
              interval: '602',
              texttableentry: 'GatewayRemoteLocalNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayApEnable',
              isRead: 'true',
              interval: '603',
              texttableentry: 'GatewayApEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayApDataSet',
              isRead: 'true',
              interval: '604',
              texttableentry: 'GatewayApDataSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIp',
              isRead: 'true',
              interval: '607',
              texttableentry: 'GatewayRemoteIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteEnable',
              isRead: 'true',
              interval: '616',
              texttableentry: 'GatewayRemoteEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSsid',
              isRead: 'false',
              interval: '617',
              texttableentry: 'GatewayRemoteSsid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIpStatic',
              isRead: 'true',
              interval: '618',
              texttableentry: 'GatewayRemoteIpStatic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteScanNetwork',
              isRead: 'true',
              interval: '619',
              texttableentry: 'GatewayRemoteScanNetwork',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DiagnosticServiceConnectionStatus',
              isRead: 'true',
              interval: '620',
              texttableentry: 'DiagnosticServiceConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSignalStrength',
              isRead: 'true',
              interval: '900',
              texttableentry: 'GatewayRemoteSignalStrength',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrix',
              isRead: 'true',
              interval: '954',
              texttableentry: 'BusTopologyMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecurityAlgorithmNumber',
              isRead: 'true',
              interval: '961',
              texttableentry: 'SecurityAlgorithmNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BackendConnectionStatus',
              isRead: 'true',
              interval: '1165',
              texttableentry: 'BackendConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleOneTwo',
              isRead: 'true',
              interval: '1233',
              texttableentry: 'GatewayRemoteVisibleOneTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleThreeFour',
              isRead: 'true',
              interval: '1234',
              texttableentry: 'GatewayRemoteVisibleThreeFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleFiveSix',
              isRead: 'true',
              interval: '1235',
              texttableentry: 'GatewayRemoteVisibleFiveSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleSevenEight',
              isRead: 'true',
              interval: '1236',
              texttableentry: 'GatewayRemoteVisibleSevenEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleNineTen',
              isRead: 'true',
              interval: '1237',
              texttableentry: 'GatewayRemoteVisibleNineTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTwo',
              isRead: 'true',
              interval: '1286',
              texttableentry: 'BusTopologyMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixThree',
              isRead: 'true',
              interval: '1287',
              texttableentry: 'BusTopologyMatrixThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFour',
              isRead: 'true',
              interval: '1288',
              texttableentry: 'BusTopologyMatrixFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFive',
              isRead: 'true',
              interval: '1289',
              texttableentry: 'BusTopologyMatrixFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigbeeEnable',
              isRead: 'true',
              interval: '1538',
              texttableentry: 'ZigbeeEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeStatus',
              isRead: 'true',
              interval: '1539',
              texttableentry: 'ZigbeeStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigbeeIdentification',
              isRead: 'true',
              interval: '1540',
              texttableentry: 'ZigbeeIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupportedFeaturesTelemetryControlUnit',
              isRead: 'true',
              interval: '1698',
              texttableentry: 'SupportedFeaturesTelemetryControlUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActivatedFeaturesTelemetryControlUnit',
              isRead: 'true',
              interval: '1699',
              texttableentry: 'ActivatedFeaturesTelemetryControlUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeOneDeviceProperty',
              isRead: 'true',
              interval: '2084',
              texttableentry: 'ZigBeeOneDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeOneDeviceSetpoint',
              isRead: 'true',
              interval: '2085',
              texttableentry: 'ZigBeeOneDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeOneDeviceCurrentValues',
              isRead: 'true',
              interval: '2086',
              texttableentry: 'ZigBeeOneDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwoDeviceProperty',
              isRead: 'true',
              interval: '2087',
              texttableentry: 'ZigBeeTwoDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwoDeviceSetpoint',
              isRead: 'true',
              interval: '2088',
              texttableentry: 'ZigBeeTwoDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwoDeviceCurrentValues',
              isRead: 'true',
              interval: '2089',
              texttableentry: 'ZigBeeTwoDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThreeDeviceProperty',
              isRead: 'true',
              interval: '2090',
              texttableentry: 'ZigBeeThreeDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThreeDeviceSetpoint',
              isRead: 'true',
              interval: '2091',
              texttableentry: 'ZigBeeThreeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThreeDeviceCurrentValues',
              isRead: 'true',
              interval: '2092',
              texttableentry: 'ZigBeeThreeDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourDeviceProperty',
              isRead: 'true',
              interval: '2093',
              texttableentry: 'ZigBeeFourDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourDeviceSetpoint',
              isRead: 'true',
              interval: '2094',
              texttableentry: 'ZigBeeFourDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourDeviceCurrentValues',
              isRead: 'true',
              interval: '2095',
              texttableentry: 'ZigBeeFourDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFiveDeviceProperty',
              isRead: 'true',
              interval: '2096',
              texttableentry: 'ZigBeeFiveDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFiveDeviceSetpoint',
              isRead: 'true',
              interval: '2097',
              texttableentry: 'ZigBeeFiveDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFiveDeviceCurrentValues',
              isRead: 'true',
              interval: '2098',
              texttableentry: 'ZigBeeFiveDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixDeviceProperty',
              isRead: 'true',
              interval: '2099',
              texttableentry: 'ZigBeeSixDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixDeviceSetpoint',
              isRead: 'true',
              interval: '2100',
              texttableentry: 'ZigBeeSixDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixDeviceCurrentValues',
              isRead: 'true',
              interval: '2101',
              texttableentry: 'ZigBeeSixDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSevenDeviceProperty',
              isRead: 'true',
              interval: '2102',
              texttableentry: 'ZigBeeSevenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSevenDeviceSetpoint',
              isRead: 'true',
              interval: '2103',
              texttableentry: 'ZigBeeSevenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSevenDeviceCurrentValues',
              isRead: 'true',
              interval: '2104',
              texttableentry: 'ZigBeeSevenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEightDeviceProperty',
              isRead: 'true',
              interval: '2105',
              texttableentry: 'ZigBeeEightDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEightDeviceSetpoint',
              isRead: 'true',
              interval: '2106',
              texttableentry: 'ZigBeeEightDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEightDeviceCurrentValues',
              isRead: 'true',
              interval: '2107',
              texttableentry: 'ZigBeeEightDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineDeviceProperty',
              isRead: 'true',
              interval: '2108',
              texttableentry: 'ZigBeeNineDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineDeviceSetpoint',
              isRead: 'true',
              interval: '2109',
              texttableentry: 'ZigBeeNineDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineDeviceCurrentValues',
              isRead: 'true',
              interval: '2110',
              texttableentry: 'ZigBeeNineDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTenDeviceProperty',
              isRead: 'true',
              interval: '2111',
              texttableentry: 'ZigBeeTenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTenDeviceSetpoint',
              isRead: 'true',
              interval: '2112',
              texttableentry: 'ZigBeeTenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTenDeviceCurrentValues',
              isRead: 'true',
              interval: '2113',
              texttableentry: 'ZigBeeTenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeElevenDeviceProperty',
              isRead: 'true',
              interval: '2114',
              texttableentry: 'ZigBeeElevenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeElevenDeviceSetpoint',
              isRead: 'true',
              interval: '2115',
              texttableentry: 'ZigBeeElevenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeElevenDeviceCurrentValues',
              isRead: 'true',
              interval: '2116',
              texttableentry: 'ZigBeeElevenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwelveDeviceProperty',
              isRead: 'true',
              interval: '2117',
              texttableentry: 'ZigBeeTwelveDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwelveDeviceSetpoint',
              isRead: 'true',
              interval: '2118',
              texttableentry: 'ZigBeeTwelveDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwelveDeviceCurrentValues',
              isRead: 'true',
              interval: '2119',
              texttableentry: 'ZigBeeTwelveDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirteenDeviceProperty',
              isRead: 'true',
              interval: '2120',
              texttableentry: 'ZigBeeThirteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirteenDeviceSetpoint',
              isRead: 'true',
              interval: '2121',
              texttableentry: 'ZigBeeThirteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2122',
              texttableentry: 'ZigBeeThirteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourteenDeviceProperty',
              isRead: 'true',
              interval: '2123',
              texttableentry: 'ZigBeeFourteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourteenDeviceSetpoint',
              isRead: 'true',
              interval: '2124',
              texttableentry: 'ZigBeeFourteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2125',
              texttableentry: 'ZigBeeFourteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFifteenDeviceProperty',
              isRead: 'true',
              interval: '2126',
              texttableentry: 'ZigBeeFifteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFifteenDeviceSetpoint',
              isRead: 'true',
              interval: '2127',
              texttableentry: 'ZigBeeFifteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFifteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2128',
              texttableentry: 'ZigBeeFifteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixteenDeviceProperty',
              isRead: 'true',
              interval: '2129',
              texttableentry: 'ZigBeeSixteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixteenDeviceSetpoint',
              isRead: 'true',
              interval: '2130',
              texttableentry: 'ZigBeeSixteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSixteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2131',
              texttableentry: 'ZigBeeSixteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSeventeenDeviceProperty',
              isRead: 'true',
              interval: '2132',
              texttableentry: 'ZigBeeSeventeenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSeventeenDeviceSetpoint',
              isRead: 'true',
              interval: '2133',
              texttableentry: 'ZigBeeSeventeenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeSeventeenDeviceCurrentValues',
              isRead: 'true',
              interval: '2134',
              texttableentry: 'ZigBeeSeventeenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEighteenDeviceProperty',
              isRead: 'true',
              interval: '2135',
              texttableentry: 'ZigBeeEighteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEighteenDeviceSetpoint',
              isRead: 'true',
              interval: '2136',
              texttableentry: 'ZigBeeEighteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeEighteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2137',
              texttableentry: 'ZigBeeEighteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineteenDeviceProperty',
              isRead: 'true',
              interval: '2138',
              texttableentry: 'ZigBeeNineteenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineteenDeviceSetpoint',
              isRead: 'true',
              interval: '2139',
              texttableentry: 'ZigBeeNineteenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeNineteenDeviceCurrentValues',
              isRead: 'true',
              interval: '2140',
              texttableentry: 'ZigBeeNineteenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyDeviceProperty',
              isRead: 'true',
              interval: '2141',
              texttableentry: 'ZigBeeTwentyDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyDeviceSetpoint',
              isRead: 'true',
              interval: '2142',
              texttableentry: 'ZigBeeTwentyDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyDeviceCurrentValues',
              isRead: 'true',
              interval: '2143',
              texttableentry: 'ZigBeeTwentyDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyOneDeviceProperty',
              isRead: 'true',
              interval: '2260',
              texttableentry: 'ZigBeeTwentyOneDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyOneDeviceSetpoint',
              isRead: 'true',
              interval: '2261',
              texttableentry: 'ZigBeeTwentyOneDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyOneDeviceCurrentValues',
              isRead: 'true',
              interval: '2262',
              texttableentry: 'ZigBeeTwentyOneDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyTwoDeviceProperty',
              isRead: 'true',
              interval: '2263',
              texttableentry: 'ZigBeeTwentyTwoDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyTwoDeviceSetpoint',
              isRead: 'true',
              interval: '2264',
              texttableentry: 'ZigBeeTwentyTwoDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyTwoDeviceCurrentValues',
              isRead: 'true',
              interval: '2265',
              texttableentry: 'ZigBeeTwentyTwoDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyThreeDeviceProperty',
              isRead: 'true',
              interval: '2266',
              texttableentry: 'ZigBeeTwentyThreeDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyThreeDeviceSetpoint',
              isRead: 'true',
              interval: '2267',
              texttableentry: 'ZigBeeTwentyThreeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyThreeDeviceCurrentValues',
              isRead: 'true',
              interval: '2268',
              texttableentry: 'ZigBeeTwentyThreeDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFourDeviceProperty',
              isRead: 'true',
              interval: '2269',
              texttableentry: 'ZigBeeTwentyFourDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFourDeviceSetpoint',
              isRead: 'true',
              interval: '2270',
              texttableentry: 'ZigBeeTwentyFourDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFourDeviceCurrentValues',
              isRead: 'true',
              interval: '2271',
              texttableentry: 'ZigBeeTwentyFourDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFiveDeviceProperty',
              isRead: 'true',
              interval: '2272',
              texttableentry: 'ZigBeeTwentyFiveDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFiveDeviceSetpoint',
              isRead: 'true',
              interval: '2273',
              texttableentry: 'ZigBeeTwentyFiveDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyFiveDeviceCurrentValues',
              isRead: 'true',
              interval: '2274',
              texttableentry: 'ZigBeeTwentyFiveDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySixDeviceProperty',
              isRead: 'true',
              interval: '2275',
              texttableentry: 'ZigBeeTwentySixDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySixDeviceSetpoint',
              isRead: 'true',
              interval: '2276',
              texttableentry: 'ZigBeeTwentySixDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySixDeviceCurrentValues',
              isRead: 'true',
              interval: '2277',
              texttableentry: 'ZigBeeTwentySixDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySevenDeviceProperty',
              isRead: 'true',
              interval: '2278',
              texttableentry: 'ZigBeeTwentySevenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySevenDeviceSetpoint',
              isRead: 'true',
              interval: '2279',
              texttableentry: 'ZigBeeTwentySevenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentySevenDeviceCurrentValues',
              isRead: 'true',
              interval: '2280',
              texttableentry: 'ZigBeeTwentySevenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyEightDeviceProperty',
              isRead: 'true',
              interval: '2281',
              texttableentry: 'ZigBeeTwentyEightDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyEightDeviceSetpoint',
              isRead: 'true',
              interval: '2282',
              texttableentry: 'ZigBeeTwentyEightDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyEightDeviceCurrentValues',
              isRead: 'true',
              interval: '2283',
              texttableentry: 'ZigBeeTwentyEightDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyNineDeviceProperty',
              isRead: 'true',
              interval: '2284',
              texttableentry: 'ZigBeeTwentyNineDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyNineDeviceSetpoint',
              isRead: 'true',
              interval: '2285',
              texttableentry: 'ZigBeeTwentyNineDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeTwentyNineDeviceCurrentValues',
              isRead: 'true',
              interval: '2286',
              texttableentry: 'ZigBeeTwentyNineDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyDeviceProperty',
              isRead: 'true',
              interval: '2287',
              texttableentry: 'ZigBeeThirtyDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyDeviceSetpoint',
              isRead: 'true',
              interval: '2288',
              texttableentry: 'ZigBeeThirtyDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyDeviceCurrentValues',
              isRead: 'true',
              interval: '2289',
              texttableentry: 'ZigBeeThirtyDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyOneDeviceProperty',
              isRead: 'true',
              interval: '2290',
              texttableentry: 'ZigBeeThirtyOneDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyOneDeviceSetpoint',
              isRead: 'true',
              interval: '2291',
              texttableentry: 'ZigBeeThirtyOneDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyOneDeviceCurrentValues',
              isRead: 'true',
              interval: '2292',
              texttableentry: 'ZigBeeThirtyOneDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyTwoDeviceProperty',
              isRead: 'true',
              interval: '2293',
              texttableentry: 'ZigBeeThirtyTwoDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyTwoDeviceSetpoint',
              isRead: 'true',
              interval: '2294',
              texttableentry: 'ZigBeeThirtyTwoDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyTwoDeviceCurrentValues',
              isRead: 'true',
              interval: '2295',
              texttableentry: 'ZigBeeThirtyTwoDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyThreeDeviceProperty',
              isRead: 'true',
              interval: '2296',
              texttableentry: 'ZigBeeThirtyThreeDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyThreeDeviceSetpoint',
              isRead: 'true',
              interval: '2297',
              texttableentry: 'ZigBeeThirtyThreeDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyThreeDeviceCurrentValues',
              isRead: 'true',
              interval: '2298',
              texttableentry: 'ZigBeeThirtyThreeDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFourDeviceProperty',
              isRead: 'true',
              interval: '2299',
              texttableentry: 'ZigBeeThirtyFourDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFourDeviceSetpoint',
              isRead: 'true',
              interval: '2300',
              texttableentry: 'ZigBeeThirtyFourDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFourDeviceCurrentValues',
              isRead: 'true',
              interval: '2301',
              texttableentry: 'ZigBeeThirtyFourDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFiveDeviceProperty',
              isRead: 'true',
              interval: '2302',
              texttableentry: 'ZigBeeThirtyFiveDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFiveDeviceSetpoint',
              isRead: 'true',
              interval: '2303',
              texttableentry: 'ZigBeeThirtyFiveDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyFiveDeviceCurrentValues',
              isRead: 'true',
              interval: '2304',
              texttableentry: 'ZigBeeThirtyFiveDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySixDeviceProperty',
              isRead: 'true',
              interval: '2305',
              texttableentry: 'ZigBeeThirtySixDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySixDeviceSetpoint',
              isRead: 'true',
              interval: '2306',
              texttableentry: 'ZigBeeThirtySixDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySixDeviceCurrentValues',
              isRead: 'true',
              interval: '2307',
              texttableentry: 'ZigBeeThirtySixDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySevenDeviceProperty',
              isRead: 'true',
              interval: '2308',
              texttableentry: 'ZigBeeThirtySevenDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySevenDeviceSetpoint',
              isRead: 'true',
              interval: '2309',
              texttableentry: 'ZigBeeThirtySevenDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtySevenDeviceCurrentValues',
              isRead: 'true',
              interval: '2310',
              texttableentry: 'ZigBeeThirtySevenDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyEightDeviceProperty',
              isRead: 'true',
              interval: '2311',
              texttableentry: 'ZigBeeThirtyEightDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyEightDeviceSetpoint',
              isRead: 'true',
              interval: '2312',
              texttableentry: 'ZigBeeThirtyEightDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyEightDeviceCurrentValues',
              isRead: 'true',
              interval: '2313',
              texttableentry: 'ZigBeeThirtyEightDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyNineDeviceProperty',
              isRead: 'true',
              interval: '2314',
              texttableentry: 'ZigBeeThirtyNineDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyNineDeviceSetpoint',
              isRead: 'true',
              interval: '2315',
              texttableentry: 'ZigBeeThirtyNineDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeThirtyNineDeviceCurrentValues',
              isRead: 'true',
              interval: '2316',
              texttableentry: 'ZigBeeThirtyNineDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourtyDeviceProperty',
              isRead: 'true',
              interval: '2317',
              texttableentry: 'ZigBeeFourtyDeviceProperty',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourtyDeviceSetpoint',
              isRead: 'true',
              interval: '2318',
              texttableentry: 'ZigBeeFourtyDeviceSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeFourtyDeviceCurrentValues',
              isRead: 'true',
              interval: '2319',
              texttableentry: 'ZigBeeFourtyDeviceCurrentValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_LogLevelEmbbededApplication',
              isRead: 'true',
              interval: '2444',
              texttableentry: 'LogLevelEmbbededApplication',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixSix',
              isRead: 'true',
              interval: '2534',
              texttableentry: 'BusTopologyMatrixSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixSeven',
              isRead: 'true',
              interval: '2535',
              texttableentry: 'BusTopologyMatrixSeven',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixEight',
              isRead: 'true',
              interval: '2536',
              texttableentry: 'BusTopologyMatrixEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixNine',
              isRead: 'true',
              interval: '2537',
              texttableentry: 'BusTopologyMatrixNine',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTen',
              isRead: 'true',
              interval: '2538',
              texttableentry: 'BusTopologyMatrixTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigBeeDevicePreConfiguredList',
              isRead: 'true',
              interval: '2562',
              texttableentry: 'ZigBeeDevicePreConfiguredList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigBeeDeviceDecoupleList',
              isRead: 'true',
              interval: '2563',
              texttableentry: 'ZigBeeDeviceDecoupleList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayInternetAccess',
              isRead: 'true',
              interval: '3097',
              texttableentry: 'GatewayInternetAccess',
              isWrite: 'true',
            },
          ],
        },
      ],
    };
  }
}
